import styles from '../templates/styles.css?inline';

const ICONS = {
  close: `<svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`,
  lock: `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>`,
  shield: `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>`
};

export class PaymentModal {
  constructor(sdk) {
    this.sdk = sdk;
    this.visible = false;
    this.container = null;

    this.totalAmount = 0;
    this.shipmentId = null;
    this.merchantId = 1;
    this.currencyCode = 'USD';

    this.onSuccessCallback = null;
    this.onErrorCallback = null;
    this.onCloseCallback = null;

    this.stripeInstance = null;
    this.stripeElements = null;
    this.stripePaymentElement = null;

    this.isLoading = false;
    this.isSubmitting = false;
    this.paymentMeta = null;
  }

  show(options = {}) {
    this.totalAmount = options.totalAmount || 0;
    this.shipmentId = options.shipmentId || null;
    this.merchantId = options.merchantId || 1;
    this.currencyCode = options.currencyCode || 'USD';

    this.onSuccessCallback = options.onSuccess || null;
    this.onErrorCallback = options.onError || null;
    this.onCloseCallback = options.onClose || null;

    this.visible = true;
    this.isLoading = true;
    this.isSubmitting = false;

    this.mountDOM();
    this.lockBodyScroll();
    this.initializeStripe();
  }

  hide() {
    this.visible = false;
    this.unlockBodyScroll();
    this.destroyStripe();

    if (this.container && this.container.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }
    this.container = null;

    if (this.onCloseCallback) {
      this.onCloseCallback();
      this.onCloseCallback = null;
    }
  }

  lockBodyScroll() {
    if (!document.body.dataset.paymentModalScrollLocked) {
      document.body.dataset.paymentModalScrollLocked = 'true';
      this._prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
  }

  unlockBodyScroll() {
    if (document.body.dataset.paymentModalScrollLocked) {
      delete document.body.dataset.paymentModalScrollLocked;
      document.body.style.overflow = this._prevOverflow || '';
    }
  }

  mountDOM() {
    if (this.container && this.container.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }

    this.container = document.createElement('div');
    this.container.id = 'shipdeez-payment-modal-root';
    this.container.style.position = 'relative';
    this.container.style.zIndex = '9999999';

    const formatUSD = (v) => `$${Number(v || 0).toFixed(2)}`;

    this.container.innerHTML = `
      <style>${styles}</style>
      <div class="payment-modal-overlay">
        <div class="payment-modal-card">

          <div class="payment-modal-header">
            <div class="payment-modal-title-row">
              <span class="payment-modal-lock-icon">${ICONS.lock}</span>
              <span class="payment-modal-title">Secure Payment</span>
            </div>
            <button type="button" class="btn-close-payment-modal" id="btn-close-payment-modal">
              ${ICONS.close}
            </button>
          </div>

          <div class="payment-modal-body">
            <div class="payment-modal-summary-box">
              <div class="payment-modal-summary-left">
                <span class="payment-modal-summary-label">Total Payment</span>
                <span class="payment-modal-summary-sub">Includes enterprise carrier discount</span>
              </div>
              <span class="payment-modal-summary-amount">${formatUSD(this.totalAmount)}</span>
            </div>

            <div id="payment-modal-loader" class="payment-modal-loader-box">
              <div class="loading-spinner-glow" style="width: 32px; height: 32px; border: 3px solid #f1f5f9; border-top-color: #f97316; border-radius: 50%; animation: spin 0.8s linear infinite; margin: 0 auto 12px;"></div>
              <span>Initializing secure checkout...</span>
            </div>

            <div id="payment-modal-error-banner" style="display: none;" class="payment-modal-error"></div>

            <div id="stripe-modal-payment-element-mount" class="payment-modal-stripe-mount" style="display: none;"></div>
          </div>

          <div class="payment-modal-footer">
            <div class="payment-modal-security-badge">
              ${ICONS.shield}
              <span>256-bit SSL Encrypted</span>
            </div>
            <div class="payment-modal-actions">
              <button type="button" class="btn-modal-cancel" id="btn-modal-cancel">Cancel</button>
              <button type="button" class="btn-modal-confirm-pay" id="btn-modal-confirm-pay" disabled>
                <span>Confirm & Pay ${formatUSD(this.totalAmount)}</span>
              </button>
            </div>
          </div>

        </div>
      </div>
    `;

    document.body.appendChild(this.container);

    // Event listeners
    const closeBtn = this.container.querySelector('#btn-close-payment-modal');
    const cancelBtn = this.container.querySelector('#btn-modal-cancel');
    const payBtn = this.container.querySelector('#btn-modal-confirm-pay');

    if (closeBtn) closeBtn.addEventListener('click', () => this.hide());
    if (cancelBtn) cancelBtn.addEventListener('click', () => this.hide());
    if (payBtn) payBtn.addEventListener('click', () => this.handleConfirmPay());

    const overlay = this.container.querySelector('.payment-modal-overlay');
    if (overlay) {
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) this.hide();
      });
    }
  }

  async initializeStripe() {
    try {
      const checkoutPayload = {
        amount: Number(this.totalAmount.toFixed(2)),
        paymentMethod: "card",
        shipmentId: this.shipmentId,
        merchantId: this.merchantId,
        currencyCode: this.currencyCode,
        origin: typeof window !== 'undefined' ? window.location.origin : "https://dev.shipdeez.com"
      };

      const checkoutRes = await fetch('https://dev-api.shipdeez.com/api/v1/Payment/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(checkoutPayload)
      });

      if (!checkoutRes.ok) throw new Error(`Payment checkout API status ${checkoutRes.status}`);

      const checkoutJson = await checkoutRes.json();
      const checkoutResult = checkoutJson?.data?.result || checkoutJson?.result || checkoutJson?.data;

      if (!checkoutResult || !checkoutResult.clientSecret) {
        throw new Error(checkoutJson?.message || 'Failed to generate payment client secret.');
      }

      this.paymentMeta = checkoutResult;

      // Ensure Stripe.js script is loaded
      if (typeof window.Stripe === 'undefined') {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://js.stripe.com/v3/';
          script.onload = resolve;
          script.onerror = () => reject(new Error('Failed to load Stripe.js SDK'));
          document.head.appendChild(script);
        });
      }

      const stripeKey = checkoutResult.publishableKey || checkoutResult.stripeKey || window.STRIPE_PUBLISHABLE_KEY || this.sdk?.config?.stripePublishableKey || 'pk_test_51T94P52eFHMnk4Mbv0yH7VPMmNeQQOPWFHZf0cnCOIdbN7cUd1J6d3zlyZBgYHz89VhQ4tvt0nQNBJjJOTePKy2600BAqTqCwd';
      this.stripeInstance = window.Stripe(stripeKey);
      this.stripeElements = this.stripeInstance.elements({
        clientSecret: checkoutResult.clientSecret,
        wallets: { link: 'never' },
        appearance: {
          theme: 'flat',
          variables: {
            colorPrimary: '#f97316',
            borderRadius: '10px'
          }
        }
      });

      const paymentElement = this.stripeElements.create('payment');
      this.stripePaymentElement = paymentElement;

      const loader = this.container.querySelector('#payment-modal-loader');
      const mount = this.container.querySelector('#stripe-modal-payment-element-mount');
      const payBtn = this.container.querySelector('#btn-modal-confirm-pay');

      paymentElement.on('ready', () => {
        this.isLoading = false;
        if (loader) loader.style.display = 'none';
        if (mount) mount.style.display = 'block';
        if (payBtn) payBtn.removeAttribute('disabled');
      });

      paymentElement.on('loaderror', (event) => {
        if (loader) {
          loader.innerHTML = `<span style="color: #ef4444;">Failed to load payment options: ${event.error?.message || 'Unknown error'}</span>`;
        }
      });

      if (mount) {
        paymentElement.mount(mount);
      }

    } catch (err) {
      console.error('PaymentModal Stripe initialization error:', err);
      this.isLoading = false;
      const loader = this.container?.querySelector('#payment-modal-loader');
      const errBanner = this.container?.querySelector('#payment-modal-error-banner');

      if (loader) loader.style.display = 'none';
      if (errBanner) {
        errBanner.style.display = 'block';
        errBanner.textContent = err.message || 'Failed to initialize payment gateway. Please try again.';
      }
    }
  }

  async handleConfirmPay() {
    if (this.isSubmitting || !this.stripeInstance || !this.stripeElements) return;

    this.isSubmitting = true;
    const payBtn = this.container?.querySelector('#btn-modal-confirm-pay');
    const errBanner = this.container?.querySelector('#payment-modal-error-banner');

    if (errBanner) {
      errBanner.style.display = 'none';
      errBanner.textContent = '';
    }

    const formatUSD = (v) => `$${Number(v || 0).toFixed(2)}`;

    if (payBtn) {
      payBtn.setAttribute('disabled', 'true');
      payBtn.innerHTML = `<span class="pay-now-spinner"></span><span>Processing Payment...</span>`;
    }

    try {
      const returnUrl = `${window.location.origin}${window.location.pathname}`;
      const { error, paymentIntent } = await this.stripeInstance.confirmPayment({
        elements: this.stripeElements,
        confirmParams: {
          return_url: returnUrl,
        },
        redirect: 'if_required'
      });

      if (error) {
        throw new Error(error.message || 'Payment confirmation failed.');
      }

      if (paymentIntent && (paymentIntent.status === 'succeeded' || paymentIntent.status === 'processing')) {
        const successData = {
          paymentIntentId: paymentIntent.id,
          amount: this.totalAmount,
          shipmentId: this.shipmentId,
          paymentMeta: this.paymentMeta
        };

        if (this.onSuccessCallback) {
          await this.onSuccessCallback(successData);
        }

        this.hide();
      } else {
        throw new Error('Payment status pending or incomplete.');
      }

    } catch (err) {
      console.error('PaymentModal confirm error:', err);
      this.isSubmitting = false;

      if (payBtn) {
        payBtn.removeAttribute('disabled');
        payBtn.innerHTML = `<span>Confirm & Pay ${formatUSD(this.totalAmount)}</span>`;
      }

      if (errBanner) {
        errBanner.style.display = 'block';
        errBanner.textContent = err.message || 'Payment failed. Please check your card details and try again.';
      }

      if (this.onErrorCallback) {
        this.onErrorCallback(err);
      }
    }
  }

  destroyStripe() {
    if (this.stripePaymentElement) {
      try {
        this.stripePaymentElement.unmount();
      } catch (e) {
        // ignore
      }
      this.stripePaymentElement = null;
    }
    this.stripeElements = null;
    this.stripeInstance = null;
  }
}
